import React, { useState } from 'react';
import './components/assets/css/custom.css';
import MainWrapper from './components/main-wrapper';
import { getHeader, getFooter } from './services/layoutService';
import Loader from './components/loader/loader';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Summary from './components/components/summary';
import CountryItem from './models/CountryIDDataLayer';
import { getQueryParam } from './services/commonService';

function App() {
  const queryParams = getQueryParam();
  let langParam =
    queryParams.get('lang') != null ? queryParams.get('lang') : '';

  let countryParam =
    queryParams.get('countryid') != null ? queryParams.get('countryid') : '';

  if (queryParams.get('countryid') != null) {
    let countrycheck = CountryItem;
    let countryID = countrycheck.CountryList.filter(
      x => x.CountryID.toLowerCase() == countryParam.toLowerCase()
    );

    if (countryID && countryID.length > 0) {
      countryParam = countryID[0].CountryID;
    } else {
      countryParam = '687PDC';
    }
  }

  const [isLoaded, setIsLoaded] = useState(false);
  const [language, setLanguage] = useState(langParam);

  function headerLanguage() {
    $(document).on('click', 'div.myparker-language', function (e) {
      setIsLoaded(true);
      e.preventDefault();
      e.stopPropagation();
      if (typeof embeddedservice_bootstrap != 'undefined')
        embeddedservice_bootstrap?.utilAPI?.removeAllComponents();

      var language = $(this).find('input.form-check-input').val();
      var lang = language;
      switch (lang) {
        case 'JP':
          lang = 'JA';
          break;
        case 'DK':
          lang = 'da';
          break;
        case 'NO':
          lang = 'NB';
          break;
      }
      setLanguage(lang);
      $(document).off('click', 'div.myparker-language');
      // var script = getHeader('687848', lang);
      // getFooter(countryParam, lang);
      // script.onload = () => {
      //   var URL = window.location.href;
      //   var cookies = document.cookie.split(';');
      //   var strenv = '';
      //   if (
      //     URL.includes('dev') ||
      //     URL.includes('test') ||
      //     URL.includes('preview') ||
      //     URL.includes('localhost')
      //   )
      //     strenv = 'test_';
      //   else strenv = 'prod_';

      //   document
      //     .getElementById('signInSection')
      //     ?.setAttribute('style', 'display: block !important');
      //   document
      //     .getElementById('userNameSection')
      //     ?.setAttribute('style', 'display: none !important');
      //   for (var i = 1; i <= cookies.length - 1; i++) {
      //     if (
      //       cookies[i].includes(strenv + 'login_flag') &&
      //       cookies[i].split('=').length > 1
      //     ) {
      //       document
      //         .getElementById('signInSection')
      //         ?.setAttribute('style', 'display: none !important');
      //       document
      //         .getElementById('userNameSection')
      //         ?.setAttribute('style', 'display: block !important');
      //     }
      //   }
      //   var signinUrl = document.getElementById('userMenu')?.href;
      //   signinUrl = signinUrl + '&fromEConfig=true';
      //   document.getElementById('userMenu')?.setAttribute('href', signinUrl);
      //   document.cookie =
      //     'eConfigURL=' +
      //     window.btoa(window.location.href) +
      //     ';domain=parker.com;path=/';
      //   var anchorTag = document.getElementsByTagName('a');
      //   for (var i = 0; i < anchorTag.length; i++) {
      //     if (anchorTag[i].innerHTML == 'Log Out') {
      //       var signoutTag = anchorTag[i];
      //       break;
      //     }
      //   }
      //   if (signoutTag) {
      //     var signoutUrl = signoutTag.href;
      //     signoutUrl = signoutUrl + 'fromEConfig=true';
      //     signoutTag.setAttribute('href', signoutUrl);
      //   }

      //   setIsLoaded(false);
      // };
      $('#language').val(lang);
      setIsLoaded(false);
    });
  }
  headerLanguage();
  return (
    <div>
      <Loader show={isLoaded} />
      <Router>
        <Routes>
          <Route
            path="/:lang?/:ControlAndValueString?/:session?/:Session?"
            element={<MainWrapper language={language} />}
          />
          <Route path="/summary/print/:session?" element={<Summary />}></Route>
        </Routes>
      </Router>
    </div>
  );
}
export default App;
